/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BoothOptionTemplateDto } from '../../models/booth-option-template-dto';
import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface BoothOptionTemplateControllerSearchV1$Params {

/**
 * 페이지 크기
 */
  pageSize?: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo?: number;

/**
 * 행사 ID
 */
  eventId?: string;

/**
 * 활성화 여부
 */
  isActive?: boolean;

/**
 * 기본 템플릿 여부
 */
  isGlobal?: boolean;

/**
 * 출처
 */
  sourceType?: 'MILLIONSHOW' | 'GOODSPACE' | 'ALLHOUSE' | 'STARTFAIR' | 'AGRITEX' | 'GIFTFAIR';
}

export function boothOptionTemplateControllerSearchV1(http: HttpClient, rootUrl: string, params?: BoothOptionTemplateControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<BoothOptionTemplateDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, boothOptionTemplateControllerSearchV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('eventId', params.eventId, {});
    rb.query('isActive', params.isActive, {});
    rb.query('isGlobal', params.isGlobal, {});
    rb.query('sourceType', params.sourceType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto & {
      'items'?: Array<BoothOptionTemplateDto>;
      }>;
    })
  );
}

boothOptionTemplateControllerSearchV1.PATH = '/api/v1/booth-option-template/search';
